/** Мок-показатели проектов по статьям для шага «База», пока нет API */

export const BASE_ARTICLES = {
  opiu: [
    "Выручка от оказания услуг",
    "Себестоимость работ",
    "ФОТ производственного персонала",
    "Субподряд",
    "Материалы",
    "Административные расходы",
    "Коммерческие расходы",
    "Прочие расходы",
  ],
  dds: [
    "Поступления от заказчиков",
    "Авансы полученные",
    "Оплата поставщикам и подрядчикам",
    "Выплата заработной платы",
    "Налоги и платежи в бюджет",
    "Аренда",
  ],
  balance: [
    "Дебиторская задолженность заказчиков",
    "Незавершённое производство",
    "Авансы выданные",
    "Кредиторская задолженность",
    "Авансы полученные",
  ],
};

const METHOD_SEED = { opiu: 3, dds: 7, balance: 11 };

/** Псевдослучайное, но стабильное число от 0 до 1 для пары «проект — статья» */
const seededRandom = (seed) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

/**
 * Показатель проекта по статье, ₸. У части проектов по отдельным статьям
 * показателя нет (0) — так видно, что проект может не получить долю.
 */
export const getProjectIndicator = (projectId, method, article) => {
  const articleIndex = BASE_ARTICLES[method].indexOf(article);
  const random = seededRandom(projectId * 97 + articleIndex * 13 + METHOD_SEED[method]);
  if (random < 0.15) return 0;
  return Math.round((500000 + random * 19500000) / 1000) * 1000;
};
